
import { useQuery } from "react-query";
import { request } from "Apis/BaseApi";
import {EloverblikAuthorizationModel} from "../Models/EloverblikAuthorizationModel";

export const ADMIN_AUTHORIZATIONS_CACHE_KEY = 'ADMIN_AUTHORIZATIONS_CACHE_KEY';
export const useAuthorizations = () => {
    return useQuery<EloverblikAuthorizationModel[]>(ADMIN_AUTHORIZATIONS_CACHE_KEY, async () => {
        return await request<EloverblikAuthorizationModel[]>({
            url: `/admin/authorizations`,
            method: 'GET',
        })
    });
}
